<template>
  <div class="crudDoubleQuery">
    <div>
      <div class="pg-clearfix bod-tb" ref="queryToolbar" v-if="buttonMenuListUrl">
        <queryToolbar
          style="float: left"
          :selectionIds="selectionIds"
          @get-all-btns="getAllBtns"
          @get-table-row="getTableRow"
          :tableRowMenu="tableRowMenu"
          :urlRemove="urlRemove"
          :store="store"
          :buttonsTopKey="buttonsTopKey"
          :buttonsRowKey="buttonsRowKey"
          :queryToolbarMenu="queryToolbarMenu"
          :routerEdit="routerEdit"
          :extendData="extendData1"
          :buttonMenuListUrl="buttonMenuListUrl"
        ></queryToolbar>
        <div class="pg-query-model-buttons pg-clearfix" v-if="queryList && queryList.length > 0">
          <span
            v-for="(item, index) in queryList"
            :key="index"
            :id="buttonMenuListUrl + '_' + item.id"
            class="pg-box-button"
            :class="{ active: item.id == detailModel }"
            @click="changeModel(item.id)"
          >
            <Icon v-if="item.icon" class="icon" :style="item.iconStyle" :custom="item.icon" />
            <span>{{ item.name }}</span>
          </span>
        </div>

        <div class="tab-tool ivu-row" v-if="ifShowTabTool">
          <TabTool
            v-model="currentTabToolValue"
            :options="tabOptions"
            @change="onTabToolChange"
          ></TabTool>
        </div>
      </div>
      <div v-if="responseData" class="remind-con">
        <newTopRemind :showHandleBtn="false" :value="responseData"></newTopRemind>
      </div>
      <topSearch
        ref="topSearch"
        v-model="page.parameters"
        @form-ok="getLocalCache"
        :searchItemsDefUrl="criteriaFormUrl"
        :ifMore="ifMore"
        :isValidate="isValidate"
        @search="search"
        @clear="searchClear"
        :isShowRightButton="isShowRightButton"
      ></topSearch>
    </div>
    <div class="pg-table-conetxt">
      <leadLoading :isBody="false" v-model="pLoading" />
      <slot name="left"></slot>
      <slot name="slotTreeClassify"></slot>
      <div class="right">
        <slot name="tab"></slot>
        <slot :page="page" :data="data">
          <div class="tableTop" ref="tableTop">
            <pangu-table
              class="tableTop-table"
              v-if="handleSortFlag"
              :showEmpty="false"
              v-model="data"
              draggable
              :extendData="extendData1"
              :errorRow="errorRow"
              :errorRowExpression="errorRowExpression"
              :highlightCurrentRow="true"
              :id="buttonMenuListUrl + '_panguTable'"
              ref="panguTable"
              :total="total"
              :disabled="topDisabled"
              :selection="selection"
              :selectionKey="dataIdKey"
              :selectionData="extendData1.rows"
              :indexLabel="indexLabel"
              :pageNo="page.pageNo"
              :pageSize="page.pageSize"
              :only-show-fields="onlyShowFields"
              :table-column-def-url="tableColDefUrl"
              :table-column-def="tableColumnDef"
              @sort-change="(order, sort) => sortChange(order, sort, 'page', 'getData')"
              @default-sort="(arr) => defaultSort(arr, 'page', 'getData')"
              @selection-change="selectionChange"
              @select="selectChange"
              @select-all="selectAllChange"
              :default-sort-val="page.sortings"
              @show-summary="showSummaryFn"
              @row-click="handleRowClick"
              height="100%"
            >
              <ElTableColumn
                :label="operateCell"
                slot="column-menu"
                v-if="tableRowMenuItem && tableRowMenuItem.length > 0"
                fixed="right"
                width="50px"
                align="center"
              >
                <template slot-scope="scope">
                  <Dropdown :transfer="true">
                    <a href="javascript:void(0)">
                      <Icon size="17" custom="ivu-icon-icon-pg-operation"></Icon>
                    </a>
                    <DropdownMenu
                      slot="list"
                      class="table-row-mun"
                      :class="buttonMenuListUrl + '_panguTable_menu_' + scope.$index"
                    >
                      <DropdownItem
                        v-for="(rowMenu, rowMenuIndex) in tableRowMenuItem"
                        :key="'tableRowMenuItem-' + rowMenuIndex"
                        v-show="computeExpress(rowMenu.showExp, scope.row)"
                      >
                        <buttonForCard
                          v-if="rowMenu.type === 'cardgen'"
                          :store="store"
                          :keyIndex="rowMenuIndex"
                          :rowMenu="rowMenu"
                          :formData="selectionIds"
                          :extendData="{ ...extendData1, rows: [scope.row] }"
                        ></buttonForCard>
                        <Button
                          v-if="!['cardgen'].includes(rowMenu.type)"
                          class="btn"
                          :class="getButtonClass(rowMenu, scope.row, 'ROW')"
                          :custom-icon="convertIcon(rowMenu.icon)"
                          :disabled="!computeExpress(rowMenu.enableExp, scope.row)"
                          @click="handleMenuClickOfRow(scope.$index, scope.row, rowMenu)"
                          >{{ rowMenu.name }}</Button
                        >
                      </DropdownItem>
                    </DropdownMenu>
                  </Dropdown>
                </template>
              </ElTableColumn>
              <!-- TODO: 授权链自定义列-->
              <ElTableColumn
                v-if="showChainLink"
                :label="chainLinkCellName"
                slot="column-menu"
                width="50px"
                align="center"
              >
                <template slot-scope="scope">
                  <div
                    style="cursor: pointer; align: center"
                    @click="onViewChain(scope.row, $event)"
                  >
                    <span style="color: #ff8c00">{{ chainLinkName }}</span>
                  </div>
                </template>
              </ElTableColumn>
            </pangu-table>
            <div class="flex flex-align-center" style="padding: 0 20px; justify-content: end">
              <span style="flex: 1" v-show="queryTime > 0">耗时 : {{ queryTime }}ms</span>
              <Page
                show-sizer
                show-total
                show-elevator
                style="float: right; margin-right: 10px"
                :page-size-opts="pageSizeOption"
                :current.sync="page.pageNo"
                :page-size.sync="page.pageSize"
                :total="page.totalCount"
                placement="top"
                @on-change="getData()"
                @on-page-size-change="pageSizeChange"
              >
              </Page>
            </div>
          </div>
          <div v-if="!queryModel" class="tableBottom" ref="tableBottom">
            <div style="height: 40px; z-index: 40; position: relative">
              <Input
                class="rightInput"
                v-model="pageDetail.keyword"
                :id="buttonMenuListUrl + '_tableDetailKeyWord'"
                prefix="icon-pg-serach"
                placeholder="商品"
                @keyup.enter.native="getDetailData"
              />
            </div>
            <pangu-table
              class="tableBottom-table"
              v-if="handleSortFlag"
              :showEmpty="false"
              v-model="dataDetail"
              draggable
              :id="buttonMenuListUrl + '_panguTableDetail'"
              ref="panguTableDetail"
              :total="totalDetail"
              :disabled="disabled"
              :indexLabel="indexLabel"
              :pageNo="pageDetail.pageNo"
              :pageSize="pageDetail.pageSize"
              :table-column-def-url="tableColDetailDefUrl"
              @sort-change="(order, sort) => sortChange(order, sort, 'pageDetail', 'getDetailData')"
              @default-sort="(arr) => defaultSortDetail(arr, 'pageDetail')"
              :default-sort-val="pageDetail.sortings"
              @show-summary="showSummaryFn"
              height="100%"
            ></pangu-table>
            <Page
              show-sizer
              show-total
              show-elevator
              style="float: right; margin-right: 10px"
              :page-size-opts="pageSizeOption"
              :current.sync="pageDetail.pageNo"
              :page-size.sync="pageDetail.pageSize"
              :total="pageDetail.totalCount"
              placement="top"
              @on-change="getDetailData()"
              @on-page-size-change="pageDetailSizeChange"
            ></Page>
          </div>
        </slot>
      </div>
    </div>
    <shuttleBoxModal
      v-if="customColumn && !shuttlegetTableCode"
      v-model="shuttleBoxModal"
      :getParams="shuttlegetParams"
      @on-reset="getTableCol"
      @on-ok="getTableCol"
      :saveParams="shuttleSaveParams"
    ></shuttleBoxModal>
    <shuttleBoxSide
      v-if="customColumn && shuttlegetTableCode"
      v-model="shuttleBoxModal"
      :getParams="shuttlegetParams"
      @on-reset="getTableCol"
      @on-ok="getTableCol"
      :saveParams="shuttleSaveParams"
    ></shuttleBoxSide>
  </div>
</template>
<script>
import { isFunction } from 'lodash-es'
import topSearch from '../topSearch/topSearch'
import { menuCommon, crudQueryMenuClick, buttonClass } from '../mixins/menuClickMixin.js'
import urlUitls from '../../static/js/urlUitls'
import objectUtil from '../../static/js/objectUtil'
import ElTableColumn from '../table/src/table-column'
import CurdQueryStore from './crudQueryStore'
import propsMixin from './propsMixin'
import templateUtil from '../../static/js/templateUtil'
import { TableSort } from '../mixins/tableCommon.js'
import TabTool from './component/TabTool.vue'
export default {
  name: 'crudDoubleQuery',
  mixins: [menuCommon, crudQueryMenuClick, buttonClass, propsMixin],
  components: {
    ElTableColumn,
    topSearch,
    TabTool,
  },
  provide() {
    return {
      parentVue: this,
    }
  },
  inject: { parentVue: { default: null } },
  props: {
    detailModel: {
      type: [String, Number],
      default: '',
    },
    // ---- #6600 增加的 props ----
    // 是否显示 Tab 标签
    showTabTool: { type: Boolean, default: false },
    // Tab 选项
    tabOptions: {
      type: Array,
      default() {
        return []
      },
    },
    // ---- end ----
    disabledGroupQueryCheckbox: { type: Boolean, default: false },
  },
  data() {
    const store = new CurdQueryStore(
      this,
      this.specialState,
      this.specialMutations,
      this.specialActions
    )
    this.currentRouter = this.$store.state.menuStore.currentRouter
    this.haveCreated = false
    const tempKey = this.cacheQueryKey ? this.cacheQueryKey : this.$route.name
    this.paramSessionKey = tempKey + this.detailModel + '_crud_query_parameter'
    const criteriaCode = urlUitls.getRequestParamter(this.criteriaFormUrl).code || '' // 获取高级查询后面的  code
    return {
      viewHeight: 100,
      showTopSearch: false,
      onlyShowFields: [],
      searchHeight: 60,
      store,
      pLoading: false, //加载动作标志位
      selectionIds: [], // 复选框选中对象id数组
      tableRowMenuItem: null, //列表的按钮组合
      extendData1: this.extendData || {}, //扩展参数混合
      //主列表查询条件
      page: {
        parameters: {}, // 高级查询表单
        criteriaCode: this.criteriaCode || criteriaCode, // 高级查询必填code。
        keyword: '',
        pageNo: 1,
        pageSize: this.getPageSizeCache(),
        totalCount: 0,
        sortings: this.urlQueryParamter?.sortings ?? null,
      },
      data: [], //主列表的数据
      total: {}, //合计的数据
      isShowSummary: false, //是否显示合计

      //详情列表查询条件
      pageDetail: {
        parameters: {}, // 高级查询表单
        criteriaCode: '', // 高级查询必填code。
        keyword: '',
        pageNo: 1,
        pageSize: 30,
        totalCount: 0,
        sortings: null,
      },
      dataDetail: [], //详情列表数据
      totalDetail: {}, //详情列表合计的数据
      showTopBtns: true, // 线上顶部按钮组
      // 接口返回的完整结构体
      responseData: null,
      queryTime: 0,
      firstGetData: false,

      // 可以处理‘排序’标志位
      handleSortFlag: false,
      // 通知排序方法，已经有缓存了，不要再去请求接口，因为排序方法一定是在cache处理完后才进行执行的
      SortCacheMemory: false,
      // #6600，当前 TabTool 的值
      currentTabToolValue: null,
      // #7197，自定义列表字段
      shuttleSaveParams: {
        type: 'LIST',
      },
      shuttlegetTableCode: null,
      shuttleBoxModal: false,
    }
  },

  watch: {
    extendData(val) {
      this.extendData1 = val
    },
  },
  created() {
    if (!this.extendData1) this.extendData1 = {}
    if (!this.extendData1.rows) this.extendData1.rows = []
    // #6600，获取默认的 Tab 值
    if (this.ifShowTabTool) {
      const arr = this.tabOptions.filter((option) => option.default)
      this.currentTabToolValue = arr?.length > 0 ? arr[0]?.value : this.tabOptions[0]?.value
    }
  },
  destroyed() {
    window.onresize = null
  },
  computed: {
    bottom() {
      //底部copyright信息存在，按钮部分的底部距离为20，如果不存在就是0
      if (this.$store.state.user.system) {
        return '20px'
      } else {
        return 0
      }
    },
    tableColDefUrl() {
      if (this.tableColumnDefUrl) {
        return this.tableColumnDefUrl
      } else if (this.tableColCode) {
        return `${this.tableColDefaultUrl}${this.tableColCode}`
      } else {
        return ''
      }
    },
    tableCode() {
      if (this.tableColCode) {
        return this.tableColCode
      } else if (this.tableColumnDefUrl?.indexOf('tableCode')) {
        return urlUitls.getRequestParamter(this.tableColumnDefUrl).tableCode
      } else {
        return null
      }
    },
    ifShowTabTool() {
      return this.showTabTool && this.tabOptions.length == 2
    },
    shuttlegetParams() {
      return {
        tableCode: this.shuttlegetTableCode ? this.shuttlegetTableCode : this.tableColCode,
      }
    },
  },
  methods: {
    //列表点击排序
    sortChange(order, sort, page, callback) {
      TableSort(order, sort, this[page], this[callback])
    },
    defaultSort(arr, page, callback) {
      this[page].sortings = arr
      if (!this.SortCacheMemory && this.initialLoad) this[callback]()
      this.$emit('on-sort')
    },
    defaultSortDetail(arr, page) {
      this[page].sortings = arr
    },
    // 刷新当前数据
    reload(updateErrors) {
      if (updateErrors) updateErrors()
      this.getData()
    },
    //刷新按钮，需要将pageNo置为1
    pageNoOneReload() {
      this.page.pageNo = 1
      this.reload()
    },
    //  返回数据更新到顶部提示信息 接口函数 :updateTopMindReload
    onTableButtonErrors(resData) {
      this.responseData = resData
    },
    //点击查询
    search(_, type) {
      // 每次只要点击查询，就直接清空子表数据 bug 26484
      this.pageDetail = {
        parameters: {}, // 高级查询表单
        criteriaCode: '', // 高级查询必填code。
        keyword: '',
        pageNo: 1,
        pageSize: 30, // 默认显示30
        totalCount: 0,
        sortings: [],
      }
      this.dataDetail = [] //详情列表数据
      this.totalDetail = {} //详情列表合计的数据

      this.page.pageNo = 1

      // #8694, 搜索前置处理
      let extendParam = {}
      if (this.searchBefore) {
        this.searchBefore({ param: extendParam, extendData: this.extendData1 })
      } else {
        extendParam = null
      }

      this.getData('search', extendParam, type)
    },
    // 清空查询条件
    searchClear(val) {
      this.setCriteriaQuery(val)
    },
    // 获取按钮所有数据
    getAllBtns(allBtns) {
      const topBtn = allBtns.find((item) => item.code === 'TOP')
      this.$nextTick(() => {
        this.showTopBtns = topBtn && topBtn.children && topBtn.children.length > 0
      })
    },
    //获取表格行的按钮组合
    getTableRow(val) {
      this.tableRowMenuItem = val
    },
    /**
     *
     * 主列表方法区域
     * **/
    //获取列表的数据
    getData(type, extendParam, searchType) {
      if (!this.firstGetData) return
      var dataOrConfig = this.getExportOfCondition(extendParam)

      // 可以处理“排序”-默认带好我们的tableCode才能排序
      if (!dataOrConfig['tableCode']) dataOrConfig['tableCode'] = this.tableCode

      this.setOnlyShowFields(dataOrConfig.parameters)
      this.setCriteriaQuery(dataOrConfig) //将查询条件存入sessionStorage
      this.$emit('on-param', dataOrConfig)
      if (searchType === 'S_change' && this.disabledGroupQueryCheckbox) return
      // 开始请求数据
      var tmpurl = this.urlQuery
      if (this.urlQueryMethod == 'get') {
        tmpurl += tmpurl.indexOf('?') > -1 ? '&' : '?'
        tmpurl += urlUitls.paramSerializer(dataOrConfig)
      }
      this.$Loading.start()
      this.pLoading = true
      this.data = []
      this.queryTime = 0
      const queryBefore = Date.now()
      // 解决 第一次从侧边栏点击菜单进入页面parameters没有取到从this.urlQueryParamter.parameters来的值
      this.extendData1.parameters = dataOrConfig.parameters

      this.$axios[this.urlQueryMethod](tmpurl, dataOrConfig)
        .then((res) => {
          this.$Loading.finish()
          //    this.$Loading.error();
          //  任务13573 备注ux要求点击查询按钮，只要报错，都用这种顶部的红色提示
          if (type) {
            if (res.data.code != 200) {
              this.$Message.error(res.data.msg)
              this.pLoading = false
              return
            }
          } else {
            if (!this.$cfn.ajax1.isOK(res, this)) {
              this.pLoading = false
              return
            }
          }

          const resData = res.data
          // 100条数据，增加Object.freeze该方法后，90M 优化到80M左右。打版本到iscc对比有显著提高：销售单， 10条数据。（35M比91M）。40条数据：68M比222M
          // var freezeData = res.data.data || []

          var freezeData = []
          // 解决明细模式下,数据id为单据id导致表格唯一键名重复问题
          if (resData.data?.length > 0) {
            freezeData = resData.data.map((im) => {
              im['_ID'] = objectUtil.createID()
              return im
            })
          }
          // 解决删除时，最后一条数据或是批量删除完时，有数据，但是，页面没有数据显示的情况
          const { totalCount } = res.data
          if (totalCount > 0 && freezeData.length === 0 && this.page.pageNo > 1) {
            this.page.pageNo = this.page.pageNo - 1
            this.getData()
            return
          }
          // objectUtil.deepFreeze(freezeData);
          this.data = freezeData
          this.page.totalCount = res.data.totalCount
          this.page.pageSize = res.data.pageSize

          // #36002, 将查询条件更新至 sessionStorage
          dataOrConfig.totalCount = this.page.totalCount
          dataOrConfig.pageSize = this.page.pageSize
          this.setCriteriaQuery(dataOrConfig)

          this.total = res.data.total
          this.$nextTick(() => {
            this.pLoading = false
            // 需求6148:动态渲染class
            this.$emit('on-dynamic-class')
          })
        })
        .catch((res) => {
          this.$cfn.ajax1.catch1(res, this)
          this.$Loading.error()
          this.pLoading = false
        })
        .finally(() => {
          this.queryTime = Date.now() - queryBefore
        })
    },
    // 需要使用菜单exportOfCondition 配合获取导出
    getExportOfCondition(extendParam) {
      var dataOrConfig = null
      this.page[this.searchKey] = this.page.keyword

      // 手动设置查询参数urlQueryParamter
      // urlQueryParamter 是配置的默认参数，取this.page 最新值来合并。 Object.assign有缺陷不支持子对象的属性合并，对于this.urlQueryParamter.parameters和this.page.parameters 2个子属性并不是合并，而是替换。
      if (this.urlQueryParamter) {
        dataOrConfig = Object.assign({}, this.urlQueryParamter, this.page)

        // 需求6870 特殊处理，手动合并sortings子属性，设置排序默认值
        if (this.urlQueryParamter.sortings && this.page.sortings.length < 1) {
          dataOrConfig.sortings = this.page.sortings.concat(this.urlQueryParamter.sortings)
        }

        // 特殊处理，手动合并parameters子属性，以this.urlQueryParamter.parameters为默认值。
        if (this.urlQueryParamter.parameters) {
          dataOrConfig.parameters = Object.assign(
            {},
            this.urlQueryParamter.parameters,
            this.page.parameters
          )
        }
      } else {
        dataOrConfig = this.page
      }

      if (this.dynamicParamter && dataOrConfig.parameters) {
        if (isFunction(this.dynamicParamter)) {
          // #6277, 合并动态参数（this.dynamicParamter 为函数）
          dataOrConfig.parameters = Object.assign(
            dataOrConfig.parameters,
            this.dynamicParamter(dataOrConfig.parameters)
          )
        } else {
          // 原来的逻辑（#6277 此需求之前），合并动态参数（this.dynamicParamter 为对象非函数）
          dataOrConfig.parameters = Object.assign(dataOrConfig.parameters, this.dynamicParamter)
        }
      }

      // #6823, 新增参数: extendParam
      if (extendParam) {
        // dataOrConfig = Object.assign(dataOrConfig, extendParam)

        // if (extendParam?.parameters) {
        //   dataOrConfig.parameters = Object.assign(dataOrConfig.parameters, extendParam.parameters)
        // }
        if (extendParam?.parameters) {
          dataOrConfig = {
            ...dataOrConfig,
            ...extendParam,
            parameters: { ...dataOrConfig?.parameters, ...extendParam.parameters },
          }
        } else {
          dataOrConfig = { ...dataOrConfig, ...extendParam }
        }
      }

      let defaultQueryParameters = this.$route.query.defaultQueryParameters
      if (defaultQueryParameters) {
        //设置初始默认查询条件
        try {
          defaultQueryParameters =
            typeof defaultQueryParameters == 'object'
              ? defaultQueryParameters
              : // : JSON.parse(defaultQueryParameters)
                eval('(' + defaultQueryParameters.replace(/\\"/g, '"') + ')')
          dataOrConfig.parameters = Object.assign(
            {},
            dataOrConfig.parameters,
            defaultQueryParameters
          )
          delete this.$route.query.defaultQueryParameters
        } catch (error) {
          console.error(error.message, defaultQueryParameters)
        }
      }

      // #6600，请求数据时增加参数
      this.updateDataOrConfig(dataOrConfig)

      return dataOrConfig
    },
    // 手动勾选数据行
    selectChange(selection, row) {
      if (this.setSelect) {
        this.setSelect(selection, row, this.data)
      }
    },
    // 全部勾选
    selectAllChange(selection) {
      if (this.setSelect) {
        this.setSelect(selection, null, this.data)
      }
    },
    //表格选中后处理
    selectionChange(selection) {
      let tempStr = selection.map((item) => {
        return objectUtil.getValueByPath(item, this.dataIdKey)
      })
      this.selectionIds = tempStr.join(',')
      // 用于业务判断。
      // 选中数据的id集合两种模式：rowIdsArray（字符串数组），rowIdsString（逗号分隔的字符串）
      // #6578，需求扩展了一个集合：rowSelectedCodes（字符串数组，选中的字段。具体字段由 this.selectedKey 配置）
      let params = {
        rows: selection,
        rowIdsArray: selection.map((item) => {
          return item.id
        }),
        rowIdsString: selection
          .map((item) => {
            return item.id
          })
          .join(','),
        rowSelectedCodes: [
          // 去重，只要数组 length > 1，则表示选中了多个值
          ...new Set(
            selection.reduce((prev, im) => {
              if (this.selectedKey && im[this.selectedKey]) prev.push(im[this.selectedKey])
              return prev
            }, [])
          ),
        ],
      }
      this.extendData1 = Object.assign({}, this.extendData1, params) // 直接修改row不会引起extendData1被监听，引起数据不能传入子组件造成错误
      if (!this.extendData1.rows) this.extendData1.rows = []
      //将查询参数放在扩展参数内
      if (!this.extendData1.parameters) this.extendData1.parameters = {}
      this.extendData1.parameters = this.page.parameters

      // 将查询列表的参数放在扩展参数内
      if (!this.extendData1.queryParameters) this.extendData1.queryParameters = {}
      this.extendData1.queryParameters = this.page
      // console.info("selectionChange", selection, this.selectionIds, this.extendData1);
    },
    //显示合计
    showSummaryFn() {
      this.isShowSummary = true
    },

    //
    //主列表页码变化更改
    pageSizeChange(index) {
      if (index === undefined) {
        return
      }
      this.page.pageSize = index
      this.setPageSizeCache()
      this.getData()
    },

    /*****
     *
     * 从列表方法区域
     * *******/
    //主列表行点击，获取详情列表
    handleRowClick(val, column) {
      if (column.label == '操作') return

      if (this.dataDetail.length && this.pageDetail.parameters[this.detailID] == val.id) {
        this.dataDetail = []
        this.$refs.panguTable.$refs.elTable.setCurrentRow()
        this.pageDetail.pageNo = 1
        this.pageDetail.totalCount = 1
        delete this.pageDetail.parameters[this.detailID]
        this.totalDetail = {}
      } else {
        this.pageDetail.keyword = null
        this.pageDetail.pageNo = 1
        this.pageDetail.totalCount = 1
        this.pageDetail.parameters[this.detailID] = val.id
        this.getDetailData()
      }
    },
    //获取详情列表的数据
    getDetailData() {
      // 开始请求数据
      var tmpurl = this.urlQueryDetail
      if (!tmpurl) return
      if (!this.pageDetail?.parameters?.[this.detailID]) return
      var parm = {
        ...this.pageDetail,
        ...this.urlQueryDetailParamter,
        parameters: { ...this.pageDetail?.parameters, ...this.urlQueryDetailParamter?.parameters },
      }
      parm.criteriaCode = this.criteriaDetailCode
      parm.tableCode = urlUitls.getRequestParamter(this.tableColDetailDefUrl).tableCode || '' // 获取从表tableCode
      if (this.urlQueryMethodDetail == 'get') {
        parm = {
          params: parm,
        }
      }
      this.$Loading.start()
      this.dataDetail = []
      this.$axios[this.urlQueryMethodDetail](tmpurl, parm)
        .then((res) => {
          this.$Loading.finish()
          if (!this.$cfn.ajax1.isOK(res, this)) {
            return
          }
          // 100条数据，增加Object.freeze该方法后，90M 优化到80M左右。打版本到iscc对比有显著提高：销售单， 10条数据。（35M比91M）。40条数据：68M比222M
          // var freezeData = res.data.data || [];
          // objectUtil.deepFreeze(freezeData);
          this.dataDetail = res.data.data
          this.pageDetail.totalCount = res.data.totalCount
          this.pageDetail.pageSize = res.data.pageSize
          this.totalDetail = res.data.total
        })
        .catch((res) => {
          this.$cfn.ajax1.catch1(res, this)
          this.$Loading.error()
        })
    },
    //详情列表页码变化更改
    pageDetailSizeChange(index) {
      if (index === undefined) {
        return
      }
      this.pageDetail.pageSize = index
      this.getDetailData()
    },

    /*****
     *
     *
     * 缓存处理区域
     *
     * *****/
    //获取pageSize的缓存
    getPageSizeCache() {
      let temp = localStorage.getItem(
        `${this.currentRouter.id}_${this.detailModel}_crudDoubleQuery_pagesize`
      )
      return temp ? Number(temp) : this.pageSize
    },
    //设置pageSize的缓存
    setPageSizeCache() {
      localStorage.setItem(
        `${this.currentRouter.id}_${this.detailModel}_crudDoubleQuery_pagesize`,
        this.page.pageSize
      )
    },
    //查询条件存入sessionStorage
    setCriteriaQuery(data) {
      if (!data && !this.ifCacheQuery) return

      sessionStorage.setItem(this.paramSessionKey, JSON.stringify(data))
    },
    // 获取 存在sessionStorage里面的查询条件
    getParamSessions() {
      let param = sessionStorage.getItem(this.paramSessionKey) || {}

      try {
        param = JSON.parse(param)
      } catch {
        param = {}
      }
      return param
    },
    // 获取缓存数据
    getLocalCache(groupQuerys) {
      this.firstGetData = true
      this.statisticalSearchList = groupQuerys
      // 请求数据前 先判断是否有缓存数据，有，直接使用缓存数据并返回
      let cacheMemory = this.$cfn.getLocalCacheMemory(
        this.currentRouter.id,
        this,
        [],
        ['pLoading', 'extendData1']
      )
      // if (cacheMemory) return
      this.extendData1.rows = []
      if (!this.extendData1.parameters) this.extendData1.parameters = {}
      if (!this.extendData1.queryParameters) this.extendData1.queryParameters = {}
      // 把 session 里面的值赋给 page， 放到页面上
      let { defaultQueryParameters } = this.$route.query
      if (this.queryKey) {
        this.$set(this.page.parameters, this.queryKey, this.$route.query[this.queryKey])
      }
      if (this.queryKeys.length > 0) {
        this.queryKeys.forEach((element) => {
          this.$set(this.page.parameters, element, this.$route.query[element])
        })
      }
      if (!defaultQueryParameters) Object.assign(this.page, this.getParamSessions())
      if (defaultQueryParameters) {
        // #7029 【灵科-web】海南高值耗材清单HIS系统直接打印
        if (typeof defaultQueryParameters === 'string') {
          try {
            defaultQueryParameters = JSON.parse(defaultQueryParameters.replace(/\\"/g, '"'))
          } catch (error) {
            console.error(
              `---- 参数 defaultQueryParameters 不合法，请传入可以 JSON.parse 解析的字符串`
            )
          }
        }

        if (typeof defaultQueryParameters === 'object') {
          Object.keys(defaultQueryParameters).forEach((key) => {
            this.$set(this.page.parameters, key, defaultQueryParameters[key])
          })
          // 置空只使用一次，避免刷新的时候，获取url参数
          delete this.$route.query.defaultQueryParameters
        }
      }
      this.extendData1.parameters = this.page.parameters
      this.extendData1.queryParameters = this.page

      // 可以处理‘排序’标志位
      this.handleSortFlag = true

      if (cacheMemory) {
        this.SortCacheMemory = true
        return
      } else {
        this.SortCacheMemory = false
      }

      //初始不加载数据
      if (!this.initialLoad) return
      this.page.pageNo = 1
    },

    /****
     *
     * 其他处理区域
     * ****/
    //计算分组的表格列字段
    setOnlyShowFields(formData) {
      if (!this.statisticalSearchList) return false
      var onlyShowFields = []
      for (var i = 0; i < this.statisticalSearchList.length; i++) {
        var item = this.statisticalSearchList[i]
        if (
          formData[item.property] &&
          item.parameter &&
          Array.isArray(item.parameter.onlyShowFields)
        ) {
          onlyShowFields = onlyShowFields.concat(item.parameter.onlyShowFields)
        }
      }
      this.onlyShowFields = [...new Set(onlyShowFields)] // 去重
    },
    //转化图标
    convertIcon(icon) {
      let str = ''
      if (icon && icon != '') {
        str = `ivu-icon-icon-pg-${icon.substr(icon.lastIndexOf('-') + 1)}`
      }
      return str
    },

    // TODO: 点击授权链查看
    onViewChain(row, evt) {
      this.$emit('on-view-chain', row, evt)
    },

    // #6600, TabTool 监听 change 事件
    onTabToolChange() {
      this.getData()
    },
    updateDataOrConfig(dataOrConfig) {
      if (this.ifShowTabTool) {
        const tabParametersPath = dataOrConfig?.tabParametersPath

        // 转换值
        const valueMap = dataOrConfig?.tabParametersValueMap
        let value = this.currentTabToolValue
        if (valueMap) {
          value = valueMap[value]
        }

        if (tabParametersPath) {
          objectUtil.setValueByPath(dataOrConfig, tabParametersPath, value)
          // 清除掉字段 dataOrConfig.tabParametersPath 和 dataOrConfig.tabParametersValueMap
          delete dataOrConfig.tabParametersPath
          delete dataOrConfig.tabParametersValueMap
        }
      }
    },
    //触发自定义列表字段方法
    shuttleBoxModalShow(menuParameter, data) {
      if (menuParameter && menuParameter.param && menuParameter.param.tableCode) {
        let shuttlegetTableCode = templateUtil.compileData(menuParameter.param.tableCode, data)
        this.shuttlegetTableCode = shuttlegetTableCode
      }
      this.shuttleBoxModal = true
    },
    getTableCol() {
      if (this.$refs && this.$refs.panguTable)
        this.$refs.panguTable.getTableColumnDefByUrl(this.tableColDefUrl)
    },
    changeModel(val) {
      this.$cfn.setNeedCache(false, this.currentRouter.id)
      this.$emit('changeModel', val)
    },
  },
  beforeDestroy() {
    //store中的除了状态(states)其他都不需缓存
    if (this.store) {
      this.store = {
        states: this.store.states,
      }
      delete this.store.states.provisional //删除页面切换时不需缓存的数据
    }
    // 销毁组件前判断当前页面是否还存活，存活缓存数据，被关闭了，就清除缓存
    this.$cfn.setLocalCacheMemory(this.currentRouter.id, this.$data, this)
    this.store = null

    this.currentTabToolValue = null
  },
}
</script>
